<template>
  <div>
    <div style="font-size:1.4rem;">希望順位</div>
    <div class="c-allocation-tableWrap">
      <table class="c-allocation-table" style="width: 100%">
        <tr v-if="allocation.name === '引越申込'">
          <th style="width: 10rem;">順位</th>
          <th></th>
        </tr>
        <tr v-else>
          <th>順位</th>
          <th></th>
          <th>ブロック</th>
          <th>種別</th>
          <th>番号</th>
          <th>税込み月額料金<br />（月額／円）</th>
          <th>枠数</th>
          <th>備考</th>
        </tr>
        <tr v-for="(block, key) in blocks" :key="key">
          <td>
            <label>
              <select
                @change="onChangeOrder(key)"
                v-model="$v.entry.entries[key].$model"
                :disabled="entry.entries[key] == 999999"
                style="width: 7rem"
              >
                <option
                  disabled
                  value="999999"
                  v-if="entry.entries[key] == 999999"
                >
                  選択不可
                </option>
                <option disabled value="">選択してください</option>
                <option
                  v-for="order in orders"
                  :key="order.value"
                  :value="order.value"
                >
                  {{ rankSelectBoxNumberStringChange(order.label) }}
                </option>
              </select>
            </label>
            <div class="error" v-if="!$v.entry.entries[key].required">
              必須です
            </div>
          </td>
          <td :style="allocation.name === '引越申込' ? 'text-align:left;' : ''">
            {{ key }}
          </td>
          <td v-if="allocation.name != '引越申込'">{{ block.type }}</td>
          <td v-if="allocation.name != '引越申込'">{{ block.no.join(",") }}</td>
          <td v-if="allocation.name != '引越申込'">
            {{ block.fee.toLocaleString() }}
          </td>
          <td v-if="allocation.name != '引越申込'">{{ block.number }}</td>
          <td v-if="allocation.name != '引越申込'">{{ block.memo }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
// import AllocationService from "../services/allocation.service";
import AllocationAreaService from "../services/allocation-area.service";
import _ from "lodash";

export default {
  name: "AllocationFreeEntry",
  props: {
    allocation: {
      type: Object,
      required: true,
    },
    entry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // allocation: {},
      areas: [],
      blocks: {},
      // entry: {
      //   spec: {
      //     name: "",
      //     length: 0,
      //     width: 0,
      //     height: 0,
      //     weight: 0,
      //     own: "購入予定",
      //   },
      //   entries: {},
      // },
      orders: [],
    };
  },
  validations() {
    console.log("Validations working");
    console.log(this.blocks);
    let entries = {};
    for (let key in this.blocks) {
      entries[key] = {
        required,
      };
    }
    return {
      entry: {
        spec: {},
        entries,
      },
    };
  },
  watch: {
    "entry.entries": {
      // immediate: true,
      handler: function(val, oldVal) {
        console.log("Watcher working"); //Does not fire when parent mutates innerKeys
        console.log(val, oldVal);
        this.checkInvalid();
      },
      deep: true,
    },
    "entry.spec": {
      handler: function(spec) {
        console.log("entry.spec:Watcher working");
        console.log(spec);
        // this.updateSpec();
        this.checkInvalid();
      },
      deep: true,
    },
  },

  async mounted() {
    console.log("Entry mounted.");
    console.log(this.entry);
    await this.$nextTick();
    // await this.loadAllocation();
    await this.loadAllocationArea();
    this.initOrders();
    if (Object.keys(this.entry.entries) == 0) {
      for (const key in this.blocks) {
        if (Object.hasOwnProperty.call(this.blocks, key)) {
          // this.entry.entries[key] = "";
          this.$set(this.entry.entries, key, "");
        }
      }
    }
  },
  methods: {
    rankSelectBoxNumberStringChange: function(number) {
      //特殊対応__順位のセレクトボックスの1を不要に変更（フリーレイアウトのみ）
      return number == 1 ? "要" : number;
    },
    checkInvalid() {
      console.log("checkInvalid");
      this.$v.$touch();
      this.$emit("invalid", this.$v.$invalid);
    },
    onBack() {
      this.$router.go(-1);
    },
    onNext() {
      console.log("onNext");
    },
    onAdd() {
      console.log("onAdd");
    },
    onDelete() {
      console.log("onAdd");
    },
    updateSpec() {
      console.log("updateSpec");
      // this.spec = spec;
      console.log(this.entry.spec);
      console.log(this.blocks);
      for (const key in this.blocks) {
        if (Object.hasOwnProperty.call(this.blocks, key)) {
          const block = this.blocks[key];
          if (
            this.entry.spec.length <= block.length &&
            this.entry.spec.width <= block.width &&
            this.entry.spec.height <= block.height &&
            this.entry.spec.weight <= block.weight
          ) {
            // this.$set(this.entry.entries, key, "");
            if (this.entry.entries[key] == 999999) {
              this.entry.entries[key] = "";
            }
          } else {
            this.entry.entries[key] = 999999;
          }
        }
      }
      console.log(this.entry);
    },
    onChangeOrder(selectedKey) {
      console.log("onChangeOrder");
      console.log("selectedKey", selectedKey);
      const value = this.entry.entries[selectedKey];
      console.log("value", value);
      const srcEntries = _.cloneDeep(this.entry.entries);
      console.log("srcEntries", srcEntries);
      let allKeys = Object.keys(this.entry.entries).sort(function(a, b) {
        return srcEntries[a] - srcEntries[b];
      });
      let sortkeys = allKeys.filter(
        key =>
          key != selectedKey &&
          srcEntries[key] != 999999 &&
          srcEntries[key] != 99999 &&
          srcEntries[key] != "",
      );
      console.log("sortkeys", sortkeys);

      if (value > 0) {
        let counter = 1;
        for (let index = 0; index < sortkeys.length; index++) {
          if (counter == value) {
            counter++;
          }
          const key = sortkeys[index];
          if (key != selectedKey) {
            this.entry.entries[key] = counter;
          }
          counter++;
        }
      }

      const destEntries = _.cloneDeep(this.entry.entries);
      console.log("destEntries1", destEntries);

      allKeys = Object.keys(destEntries).sort(function(a, b) {
        return destEntries[a] - destEntries[b];
      });
      sortkeys = allKeys.filter(
        key =>
          srcEntries[key] != 999999 &&
          srcEntries[key] != 99999 &&
          srcEntries[key] != "",
      );
      console.log("sortkeys2", sortkeys);

      let counter = 1;
      for (let index = 0; index < sortkeys.length; index++) {
        let key = sortkeys[index];
        this.entry.entries[key] = counter;

        counter++;
      }

      console.log("destEntries2", this.entry.entries);
    },
    initOrders() {
      this.orders = [{ label: "不要", value: 99999 }];
      let counter = 1;
      for (const key in this.blocks) {
        if (Object.hasOwnProperty.call(this.blocks, key)) {
          // const block = this.blocks[key];
          this.orders.push({
            label: counter,
            value: counter,
          });
          counter++;
        }
      }
      console.log("orders", this.orders);
    },
    // async loadAllocation() {
    //   const response = await AllocationService.findByID(this.$route.params.id);
    //   this.allocation = response.data;
    //   console.log(this.allocation);
    // },
    async loadAllocationArea() {
      console.log("loadAllocationArea");
      const response = await AllocationAreaService.find({
        allocation: this.allocation._id,
      });
      this.areas = response.data;
      console.log(this.areas);

      this.blocks = {};
      for (let index = 0; index < this.areas.length; index++) {
        const area = this.areas[index];
        if (this.blocks[area.block] === undefined) {
          this.blocks[area.block] = {
            type: area.type,
            no: [area.no],
            length: area.length,
            width: area.width,
            height: area.height,
            weight: area.weight,
            memo: area.memo,
            fee: area.fee,
            number: area.number,
          };
        } else {
          this.blocks[area.block].no.push(area.no);
        }
      }
      console.log("blocks", this.blocks);
    },
  },
};
</script>
